import React, {FC} from 'react'
import CountUp from 'react-countup'

type PropsStat = {
  end: number,
  bg: string,
  textColor: string,
  border: string,
  title: string,
}

const Card6: FC<PropsStat> = ({end, bg, border, textColor, title}) => {

  return (
    <>
      <div
        className={`border border-${border} bg-${bg} border-dashed rounded min-w-80px min-w-sm-125px py-3 px-4 me-3`}>
        <div className="d-flex align-items-center">
          <div className={`fs-2 fw-bolder ${textColor}`}>
            <CountUp start={0} end={end} duration={1.2} />
          </div>
        </div>
        <div className={`fw-bold fs-6 ${textColor}`}>{title}</div>
      </div>
    </>
  )
}

export {Card6}